var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "vab-footer" },
    [
      _vm._v(" Copyright "),
      _c("vab-icon", { attrs: { icon: "copyright-line" } }),
      _vm._v(
        " " +
          _vm._s(_vm.fullYear) +
          " 哥弟商元贸易有限公司版权所有 鄂ICP备2020021026号 "
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }